<template>
  <card>
    <div class="container">
      <div style="margin: 10px 10px 10px 10px;">
        <el-row>
          <el-col :span="18" >
            <div class="noShow">123</div>
            <!-- <el-button type="warning" @click="createModal()">新增合約</el-button> -->
          </el-col>
          <el-col :span="6">
            <el-input placeholder="Search" v-model="filters[0].value"></el-input>
          </el-col>
        </el-row>
      </div>

      <data-tables
        :data="tableData"
        :pagination-props="{ pageSizes: [15, 25, 50] }"
        :filters="filters"
        :table-props="tableProps"
      >
        <el-table-column label="#" prop="index" sortable="custom" min-width="20px">
          <template slot-scope="scope">{{scope.row.index}}</template>
        </el-table-column>
        <el-table-column label="方案" prop="plan" sortable="custom" min-width="30px">
          <template slot-scope="scope">{{scope.row.plan}}</template>
        </el-table-column>
        <el-table-column label="起始日" prop="plan" sortable="custom" min-width="30px">
          <template slot-scope="scope">{{scope.row.start}}</template>
        </el-table-column>
        <el-table-column label="截止日" prop="plan" sortable="custom" min-width="30px">
          <template slot-scope="scope">{{scope.row.end}}</template>
        </el-table-column>
        <el-table-column label="系統截止日" prop="plan" sortable="custom" min-width="30px">
          <template slot-scope="scope">{{scope.row.sysEnd}}</template>
        </el-table-column>
        <el-table-column label="合約訂單編號" prop="plan" sortable="custom" min-width="30px">
          <template slot-scope="scope"><router-link :to="'../../../registrations/' + scope.row.registrationOrderId">{{scope.row.orderId}}</router-link></template>
        </el-table-column>
        <el-table-column label="合約狀態" prop="plan" sortable="custom" min-width="30px">
          <template slot-scope="scope">{{scope.row.status}}</template>
        </el-table-column>
        <el-table-column label="系統狀態" prop="plan" sortable="custom" min-width="30px">
          <template slot-scope="scope">{{scope.row.sysStatus}}</template>
        </el-table-column>

        <el-table-column label="操作" min-width="20px">
          <template slot-scope="scope">
            <!-- <n-button type="info" size="sm" @click.native="edit(scope.row)">
              <span>修改</span>
            </n-button>
            <n-button type="info" @click.native="modals.newContract = true">
              修改合約
            </n-button> -->
            <!-- <n-button v-if="!scope.row.isClosed" type="primary" @click.native="stop()">
              停用系統
            </n-button>
            <n-button v-else type="primary" @click.native="start()">
              啟用系統
            </n-button> -->
          </template>
        </el-table-column>
      </data-tables>
    </div>
    <n-button native-type="button" type="gray" @click.native="home()">
      回商店列表
    </n-button>

    <modal :show.sync="modals.newContract" headerclasses="justify-content-center">
      <h4 slot="header" class="title title-up">新增合約</h4>
      <div class="row">
        <label class="col-sm-3 col-form-label">選擇方案</label>
        <div class="col-sm-8">
          <el-select
            class="select-primary"
            size="large"
            placeholder="選擇方案"
            v-model="newContractData.selectedPlan"
            @change="selectChange()"
          >
            <el-option
              v-for="option in newContractData.options"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-3 col-form-label">合約起始日</label>
        <div class="col-sm-8">
          <fg-input>
            <el-date-picker v-model="newContractData.start" type="date" placeholder="選擇日期" :picker-options="pickerOptions1">
              </el-date-picker>
          </fg-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-3 col-form-label">合約截止日</label>
        <div class="col-sm-8">
          <fg-input>
            <el-date-picker v-model="newContractData.end" type="date" placeholder="選擇日期" :picker-options="pickerOptions1">
              </el-date-picker>
          </fg-input>
        </div>
      </div>
      <div v-if="registrationOrders && registrationOrders.length" class="row">
        <label class="col-sm-3 col-form-label">是否綁定申請表單</label>
        <div class="col-sm-8">
          <el-select
            class="select-primary"
            size="large"
            placeholder="選擇訂單"
            v-model="newContractData.selectedOrder"
          >
            <el-option
              v-for="order in registrationOrders"
              class="select-primary"
              :value="order.id"
              :label="order.orderId + ' (' + order.createdTime + ')'"
              :key="order.id"
            ></el-option>
          </el-select>
        </div>
      </div>

      <template slot="footer">
        <n-button @click.native="modals.classic = false">取消</n-button>
        <n-button type="danger" @click.native="create()">新增</n-button>
      </template>
    </modal>
  </card>
</template>

<script>
import ElementUI from "element-ui";
import { fetchContract, fetchPlans } from "src/javascripts/gaa/fetchData";
import { createContract, enable, disable } from "src/javascripts/gaa/postData";
import moment from "moment-timezone";
import { Modal } from 'src/components'
import swal from "sweetalert2";
import axios from "axios";

var accountId = "";
var businessId = "";
export default {
  components: {
    Modal
  },
  beforeRouteEnter(to, from, next) {
    console.log("this.$route: ", to);
    businessId = to.query.businessId;
    console.log("businessId: ", businessId);
    let id = to.params.id;
    accountId = id;
    let fetchContractData = {
      accountId: id,
      businessId
    };
    // next(vm => vm.setData(res.data));
    var data = {};
    fetchContract(fetchContractData)
      .then(res => {
        console.log("fetchContract: ", res);
        data.contractData = res.data;
        return fetchPlans()
      })
      .then(res => {
        console.log("fetchPlans: ", res);
        data.plans = res.data;
        next(vm => vm.setData(data));
      })
      .catch(err => {
        console.log("err: ", err);
      });

  },
  data() {
    return {
      plans: [],
      tableData: [{
        start: "",
        end: "",
        sysEnd: "",
        orderId: "",
        registrationOrderId: "",
        plan: "",
        status: ""
      }],
      filters: [
        {
          prop: ["accountId", "name"],
          value: ""
        }
      ],
      tableProps: {
        defaultSort: {
          prop: 'accountId',
          order: 'descending'
        }
      },
      modals: {
        newContract: false,
        editContract: false
      },
      pickerOptions1: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        },
        {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        },
        {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      datePicker: '',
      newContractData: {
        
      },
      registrationOrders: []
    };
  },
  methods: {
    setData(data) {
      this.tableData = data.contractData.map((d, index) => {
        return Object.assign({}, {
          index: index+1,
          start: moment(d.startTime).tz('Asia/Taipei').format("YYYY-MM-DD"),
          end: moment(d.endTime).tz('Asia/Taipei').format("YYYY-MM-DD"),
          sysEnd: moment(d.sysEndTime).tz('Asia/Taipei').format("YYYY-MM-DD"),
          orderId: d.orderId,
          registrationOrderId: d.registrationOrderId,
          plan: d.planName,
          status: d.status,
          sysStatus: d.sysClosed ? "OFF" : "ON",
          isClosed: d.sysClosed
        });
      });
      this.plans = data.plans.map(d => {
        return Object.assign({}, d);
      })
      console.log(this.tableData)
      console.log(this.plans)
    },
    edit(row) {
      console.log("edit", row);
      this.modals.newContract = true;

    },
    createModal() {
      console.log("create");
      let options = this.plans.map(d => {
        return Object.assign({}, {
          id: d.id,
          name: d.plan
        });
      });
      this.modals.newContract = true;
      this.newContractData = Object.assign({},{
        options: options,
        start: "",
        end: "",
        selectedPlan: "",
        selectedOrder: "",
        sysEnd: "",
        status: "normal"
      });

    },
    create() {
      this.newContractData.start = moment(this.newContractData.start).tz("Asia/Taipei").format("YYYY-MM-DD")
      this.newContractData.end = moment(this.newContractData.end).tz("Asia/Taipei").format("YYYY-MM-DD")
      this.newContractData.sysEnd = moment(this.newContractData.end).add(7, 'd').tz("Asia/Taipei").format("YYYY-MM-DD")
      console.log("newContractData: ", this.newContractData);
      // insert into contracts
      let createContractData = {
        shopId: accountId,
        businessId,
        start: this.newContractData.start,
        end: this.newContractData.end,
        sysEnd: this.newContractData.sysEnd,
        plan: this.newContractData.selectedPlan,
        registrationOrderId: this.newContractData.selectedOrder,
        status: this.newContractData.status
      }
      createContract(createContractData)
      .then(res => {
        console.log("createContract: ", res.data)
        if(res.data.insertId > 0) {
          window.location.reload();
        } else {
          swal("新增合約失敗");
        }
      })
      .catch(err => {
        console.log("err: ", err);
      });

    },
    stop() {
      console.log("stop")
      disable(accountId)
      .then(res => {
        window.location.reload();
      })
      .catch(err => {
        console.log("err: ", err);
      })
    },
    start() {
      console.log("start")
      enable(accountId)
      .then(res => {
        window.location.reload();
      })
      .catch(err => {
        console.log("err: ", err);
      })
    },
    selectChange() {
      console.log("selectChange: ", this.newContractData.selectedPlan);

    },
    home: function() {
      window.history.back();
    },
    getRegistrationOrders() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/shops/${
            businessId
          }/registration-orders`
        )
        .then(response => {
          
          self.registrationOrders = response.data;
          if (self.registrationOrders) {
            for (let i = 0; i < self.registrationOrders.length; ++i) {
              if (self.registrationOrders[i].createdTs) {
                self.registrationOrders[i].createdTime = moment.unix(self.registrationOrders[i].createdTs).format('YYYY-MM-DD HH:mm:ss');
              }
            }
          }
        });
    }
  },
  mounted() {

    // 檢查是否有關聯的開店訂單資料
    // 如果有，抓出合約資訊
    this.getRegistrationOrders();
  }
  // updated: function() {
    
  // }
};
</script>
<style lang="scss" scoped>
.noShow {
  opacity: 0;
}
</style>